export default {
  watch: {
    'pagination.where': {
      handler() {
        if (!this.entityFilterName) throw new Error('@error: Indlex missing entity name');

        if (this.pagination.where !== undefined) {
          sessionStorage.setItem(
            this.entityFilterName,
            JSON.stringify(this.pagination.where),
          );
        }
      },
    },
  },
  computed: {
    entityFilterName() {
      return this.entityName
        ? `${this.entityName}_filters`
        : null;
    },
  },
  created() {
    let where = sessionStorage.getItem(this.entityFilterName);
    if (where) {
      // Ignore "x => true" filter, not idea from where it comes.
      where = (JSON.parse(where) || []).filter(x => x !== 'x => true');
      this.pagination.where = where;
    }
  }
};